import { CheckResult } from '../../types';
import { ChatActionType, ChatActionTypes } from '../chat';

export function newCheckAnswerToHistory(res: CheckResult): ChatActionTypes {
  return {
    type: ChatActionType.NEW_CHECK_ANSWER_LOADED,
    data: res,
  };
}
